import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../../../app.service";
import { ListPageBase } from "../../../shared/components/list-page-base/list-page-base";
import { StatePersistingService } from "../../../shared/services/state-persisting.service";
import { AttachmentTypeListItemDto } from "../../../shared/models/attachment/attachment-type-list-item-dto";
import { AttachmentTypesService } from "../../../shared/services/attachment-types.service";
import { ExportExcelFromGridService } from "../../../shared/services/export-excel-from-grid.service";

@Component({
	selector: 'attachment-types-list',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss']
})
export class AttachmentTypesListPage extends ListPageBase<AttachmentTypeListItemDto> {

	constructor(
		protected appService: AppService,
		protected router: Router,
		protected dataService: AttachmentTypesService,
		protected persistingService: StatePersistingService,
		protected exportExcelFromGridService: ExportExcelFromGridService)
	{
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Типы вложений';
	}

	onListPageInit(): void {

	}

	processListItems(items: AttachmentTypeListItemDto[]): void {

	}

	public cellClick({ dataItem }: any): void {
		this.router.navigate(['/categories/attachment-type', dataItem.attachmentTypeId]);
	}

}
